import { BaseIdNotRequiredRequest } from "../../../../base/request/BaseIdNotRequiredRequest";

/** Request de alta de un monitor de campo (`POST
 *  /configuracion/monitoreos-usuarios/save`). **No lleva `pin`**: lo genera el
 *  server y solo viaja de vuelta en la response. */
export type MonitoreoUsuarioRequest = BaseIdNotRequiredRequest & {
  /** Cliente al que pertenece el monitor. */
  clienteId: string;
  /** Nombre del monitor. Requerido por el server. */
  nombre: string;
  /** Correo al que se le envían las credenciales. Requerido por el server. */
  email: string;
};

/** Crea el request de alta de un monitor. El `id` va `null`: la UI solo da de
 *  alta — activar/inactivar tienen sus propios endpoints y no hay edición. */
export const fx_createMonitoreoUsuarioRequest = (
  clienteId: string,
  nombre: string,
  email: string,
): MonitoreoUsuarioRequest => {
  return {
    id: null,
    clienteId: clienteId,
    nombre: nombre,
    email: email,
  };
};
